export enum StatusSdpQueue {
  IN_QUEUE = 'modules.data-management.serien-daten.spd-queue.status-in-queue',
  CREATING = 'modules.data-management.serien-daten.spd-queue.status-creating',
  WAITING_FOR_DEPLOYMENT = 'modules.data-management.serien-daten.spd-queue.status-waiting-for-deployment',
  DEPLOYING = 'modules.data-management.serien-daten.spd-queue.status-deploying',
  ERROR = 'modules.data-management.serien-daten.spd-queue.status-error',
}
